export default __webpack_public_path__ + "static/media/home-hero-bf-1.5574211e.png";